import { FaInbox, FaPaperPlane, FaFileAlt, FaTrash, FaFolder } from "react-icons/fa";

const FOLDER_ICONS = {
  INBOX: FaInbox,
  Sent: FaPaperPlane,
  Enviados: FaPaperPlane,
  Drafts: FaFileAlt,
  Borradores: FaFileAlt,
  Trash: FaTrash,
  Papelera: FaTrash,
};

const getFolderIcon = (name) => {
  for (const [key, Icon] of Object.entries(FOLDER_ICONS)) {
    if (name?.toLowerCase().includes(key.toLowerCase())) return Icon;
  }
  return FaFolder;
};

const FolderList = ({ folders, activeFolder, onSelectFolder }) => {
  if (!folders || folders.length === 0) return null;

  return (
    <div className="py-1">
      {folders.map((folder) => {
        const Icon = getFolderIcon(folder.name);
        const isActive = activeFolder === folder.path;
        return (
          <button
            key={folder.path}
            onClick={() => onSelectFolder(folder.path)}
            className={`w-full flex items-center gap-2.5 px-4 py-1.5 text-left transition-colors
              ${isActive ? "bg-orange-50 text-orange-600" : "text-gray-600 hover:bg-gray-100"}`}
          >
            <Icon className="text-[11px] flex-shrink-0" />
            <span className="text-[11px] font-medium truncate">{folder.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FolderList;
